// Scroll to top of product grid when a filter is applied
document.addEventListener('change', function (e) {
  if (e.target.closest('.facets--vertical')) {
    const productGrid = document.querySelector('.product-grid-container');
    if (productGrid) {
      const offset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height') || '60');
      const top = productGrid.getBoundingClientRect().top + window.scrollY - offset - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
});
